// Pure ratio evaluation for the Object Conversion KPI tile — no React dependencies.
//
// Unlike EfficiencyKPI (sum of numeric attributes over one shared object set),
// this tile's numerator and denominator are each an independent object COUNT
// scoped by their own activity condition — resolved server-side via two
// separate /ocel/object-table calls (aggregations.total_objects).

/**
 * @param {{ numeratorCount: number|null|undefined, denominatorCount: number|null|undefined }} params
 * @returns {{ value: number, error: null } | { value: null, error: 'MISSING_DATA' | 'DENOMINATOR_ZERO' }}
 */
export const computeConversionRatio = ({ numeratorCount, denominatorCount }) => {
  if (
    numeratorCount === undefined || numeratorCount === null ||
    denominatorCount === undefined || denominatorCount === null
  ) {
    return { value: null, error: 'MISSING_DATA' };
  }
  if (denominatorCount === 0) {
    return { value: null, error: 'DENOMINATOR_ZERO' };
  }
  return { value: (numeratorCount / denominatorCount) * 100, error: null };
};
